<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
        <div class="modal-body text-center mt-4">
          <table class="table">
            <thead class="thead-dark text-center">
              <th v-for="row in thead" :key="row">
                {{ row }}
              </th>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tbody" :key="'tbody-' + i">
                <td>{{ row }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-treid" @click="handleClilickSend">Aceptar</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalTable",
  props: {
    visible: Boolean,
  },
  data() {
    return {
      thead: [],
    };
  },
  methods: {
    handleClilickSend() {
      this.$parent.modalTable.visible = false;
    },
  },
  created: function () {
    this.thead = Object.keys(this.$parent.modalTable.table);
    this.tbody = this.$parent.modalTable.table[this.thead];
  },
};
</script>
<style lang="css" scoped>
</style>